export const fetchitems = {
  init() {
    const caseTags = [...document.querySelectorAll('.js-tag-input')] || null;
    const filterTags = [...document.querySelectorAll('.js-tag-filter-input')] || null;

    // Sets the correct colour to each caseTag
    caseTags?.forEach(caseTag => this.colorTags(caseTag));

    // Sets the correct colour to each filterTag and adds the event used to filter cases
   filterTags?.forEach(filterTag => {
      this.colorTags(filterTag);
      filterTag.addEventListener('change', this.onTagFilterChange);
   });
  },

  onTagFilterChange() {
    const selectedFilters = [...document.querySelectorAll('.js-tag-filter-input:checked')];
    const tagsList = [];

    selectedFilters?.forEach(filter => {
      tagsList.push(filter.dataset.tag.toLowerCase());
    });

    // Converts the tagsList to a string and replaces # with %23
    const stringTagList = tagsList.join().replace('#', '%23');

    const fetchUrl = `${window.location.pathname}?q=${stringTagList}`;

    fetch(fetchUrl, defaultParameters)
      .then(res => res.json())
      .then(data => {

        if (data.success) {
          fetchitems.onFetchSuccess(data, true);
        }

        const caseTags = [...document.querySelectorAll('.js-tag-input')];
        if (caseTags.length) {
          caseTags.forEach(caseTag => {
            fetchitems.colorTags(caseTag);
          });
        }
      });

    fetchitems.pushQuery(tagsList);
  },

  onFetchSuccess(data) {

    if (data.view) {
      const rowContainer = document.querySelector('.js-caselist-wrapper');

      rowContainer.innerHTML = data.view;
      fetchitems.init();
    }
  },

  pushQuery(tagsList) {
    // Maps tagsList so that every item has it's # replaced with %23
    const mappedTagsList = tagsList.map(tag => tag.replace('#', '%23'));

    history.pushState(null, null, '?q=' + mappedTagsList);
  },

  colorTags(tag) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const paramsContainTag = params.q?.toLowerCase().includes(tag.dataset.tag.toLowerCase());

    if (paramsContainTag) {
      tag.classList.add('tag--inverted');
      tag.checked = true;
    } else {
      tag.classList.remove('tag--inverted');
      tag.checked = false;
    }
  }
};

export const defaultParameters = {
  credentials: 'include',
  headers: {
    Accept: 'text/html',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
